import React from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { switchTab } from "../../store/picks/tabs-slice";
import {
  clearAllUserPicks,
  setShouldShowYourPick,
} from "../../store/picks/userPick-slice";
import store from "../../store/store";
import { playAudioEffect } from "../../store/audio-slice";
import { AudioEnum } from "../../enums";

const SwitchTabArrow: React.FC = () => {
  const drawStarted = useAppSelector((state) => state.tab.drawStarted);
  const dispatch = useAppDispatch();

  if (drawStarted) {
    return null;
  }

  const arrowClickHandler = (): void => {
    if (store.getState().picks.shouldShowYourPick) {
      dispatch(clearAllUserPicks());
    }
    dispatch(setShouldShowYourPick(false));
    dispatch(switchTab());
  };

  return (
    <div className="slides bet">
      <button
        type="button"
        className="next prev_next"
        onClick={() => {
          arrowClickHandler();
          dispatch(playAudioEffect(AudioEnum.EFFECT_DRAW));
        }}
      >
        <span className="first_arrow arrow">&#10095;</span>
        <span className="last_arrow arrow">&#10095;</span>
      </button>
    </div>
  );
};

export default SwitchTabArrow;
